import * as texts from '../../locale/languages/ES/Es.json'

export const useLabels = () => ({ texts })
